// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_userinfo.scss
// module id = 57
// module chunks = 0